<template>
  <div style="height: 100%;background-color: #fbfbfb">
    <div style="height: 100%;margin: 0 20px">
      <div style="height: 50px;padding-top: 20px">
        <el-button type="primary" plain icon="el-icon-plus" @click="addBtn()">新增</el-button>
        <!--        <el-input prefix-icon="el-icon-search" placeholder="输入名称查询" style="width: 250px"></el-input>-->
        <!--        <el-button type="success" @click="queryDataTable">查询</el-button>-->
      </div>
      <div style="max-height: calc(100% - 120px);overflow-y: auto">
        <el-table :data="tableData" border highlight-current-row ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="participants"
            label="参与人"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="name"
            label="活动名称"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            prop="location"
            label="活动地点"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="相关餐厅"
            min-width="80"
            align="center">
            <template slot-scope="scope">
              <span>{{getRestaurantName(scope.row.restaurantid)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="eventtime"
            label="时间"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="计划方案照片"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.planpictures" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column
            label="签到照片"
            min-width="120"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.signpictures" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column
            label="现场图片"
            min-width="190"
            align="center">
            <template slot-scope="scope">
              <img style="height: 100px" v-for="item in scope.row.livepictures" :key="item.index" :src="item.url">
            </template>
          </el-table-column>
          <el-table-column
            prop="desc"
            label="备注"
            min-width="80"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="80">
            <template slot-scope="scope">
              <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editBtn(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delBtn(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                       :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px" top="5vh"
               :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <span>{{ addEditTitle }}</span>
        <div class="line-title"></div>
      </div>
      <add-edit-safety :addEditObj="addEditObj" v-model="addEditShow" @updateTable="updateTable"></add-edit-safety>
    </el-dialog>
  </div>
</template>

<script>
import {getToken} from '../../utils/auth'
import {queryrestaurant, querysafety, deletesafety} from '../../api/yanglaoyuan'
import addEditSafety from './components/addEditSafety'
export default {
  name: 'foodSafetyRecord',
  components: {addEditSafety},
  data () {
    return {
      token: '',
      entityId: 0,
      restaurants: [], // 餐厅
      dishes: [], // 菜品
      dishpackages: [], // 套餐
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      addEditTitle: '',
      addEditShow: false,
      addEditObj: {
        restaurants: [], // 餐厅
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.token = getToken()
    this.entityId = this.$store.state.user.LoginResp.entity_id
    this.getRestaurants()
  },
  methods: {
    // 餐厅
    getRestaurants () {
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        eid: this.entityId
      }
      queryrestaurant(params, data).then(res => {
        this.restaurants = res.data.restaurants
        this.addEditObj.restaurants = res.data.restaurants
        this.queryDataTable()
      })
    },
    queryDataTable () {
      let params = {
        size: this.pageSize,
        page: this.currentPage
      }
      let data = {
        eid: this.entityId
      }
      querysafety(params, data).then(res => {
        let table = []
        let arr = res.data.foodsafetyevents
        for (let i = 0; i < arr.length; i++) {
          let obj = arr[i]
          obj.signpictures = this.getImgUrls(obj.signpicture)
          obj.livepictures = this.getImgUrls(obj.livepicture)
          obj.planpictures = this.getImgUrls(obj.planpicture)
          table.push(obj)
        }
        this.tableData = table
        this.totalCells = res.data.cnt
      })
    },
    getImgUrls (picture) {
      let url = this.commonType.getapi() + 'food/image/'
      let list = []
      let arr = picture.split(',')
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== '') {
          let photoUrl = url + arr[i] + '?token=' + getToken()
          let obj = {
            filename: arr[i],
            url: photoUrl
          }
          list.push(obj)
        }
      }
      return list
    },
    getRestaurantName (id) {
      let name = id
      for (let i = 0; i < this.restaurants.length; i++) {
        if (id === this.restaurants[i].id) {
          name = this.restaurants[i].name
        }
      }
      return name === 0 ? '' : name
    },
    addBtn () {
      this.addEditTitle = '新增安全记录'
      this.addEditObj.isAdd = true
      this.addEditObj.row = ''
      this.addEditShow = true
    },
    editBtn (row) {
      this.addEditTitle = '编辑安全记录'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    delBtn (row) {
      this.$confirm('此操作将永久删除该安全记录【' + row.name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletesafety(data).then(res => {
          this.$notify({title: '成功', message: '成功删除该安全记录', type: 'success', duration: 2000})
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.queryDataTable()
        })
      })
    },
    updateTable () {
      this.queryDataTable()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.queryDataTable()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryDataTable()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/foodSafetyRecord.vue